'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chunk = require('lodash/chunk');

var _chunk2 = _interopRequireDefault(_chunk);

var _uniqueId = require('lodash/uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _itemPreview = require('./item-preview');

var _itemPreview2 = _interopRequireDefault(_itemPreview);

var _Utility = require('../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _MainStore = require('../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _reactScroll = require('react-scroll');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemList = function (_React$Component) {
    _inherits(ItemList, _React$Component);

    function ItemList(props) {
        _classCallCheck(this, ItemList);

        var _this = _possibleConstructorReturn(this, (ItemList.__proto__ || Object.getPrototypeOf(ItemList)).call(this, props));

        _this.state = {
            items: []
        };

        // this.onChange          = this.onChange.bind(this);
        _this.renderItemDetails = _this.renderItemDetails.bind(_this);
        return _this;
    }

    _createClass(ItemList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // console.log(this.props);
            // console.log("item-list");
        }
    }, {
        key: 'render',
        value: function render() {

            // check the location menu is configured as ROW
            // const isMenuTypeRowConfig = MainStore.isMenuTypeRow();

            // get date time based on the location
            var dateTime = _MainStore2.default.getCurrentDateTime();

            var categoryName = this.props.category;
            var id = this.props.category;

            if (this.props.parentCategory) {
                id = this.props.parentCategory + "_" + categoryName;
                categoryName = '' + categoryName;
            }
            id = id.trim().replace(/[^A-Z0-9]+/ig, "_");
            // console.log("categoryName: " + categoryName);
            // console.log("item id: " + id)

            return _react2.default.createElement(
                _reactScroll.Element,
                {
                    name: id.toString(),
                    className: id,
                    key: "display" + id
                },
                _react2.default.createElement(
                    'div',
                    { className: "row", key: id },
                    _react2.default.createElement(
                        'div',
                        { className: "col-12" },
                        _react2.default.createElement(
                            'h4',
                            { className: 'font-weight-bold mt-3 mb-2' },
                            categoryName,
                            this.props.openHours ? _react2.default.createElement(
                                'small',
                                { className: ' h6 ml-2' },
                                Utils.getTodaysOpeningHours(this.props.openHours, dateTime)
                            ) : null
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            this.props.groupDesc
                        )
                    ),
                    this.renderItemDetails()
                )
            );
        }
    }, {
        key: 'renderItemDetails',
        value: function renderItemDetails() {
            var _this2 = this;

            // check the location menu is configured as ROW
            var isMenuTypeRowConfig = _MainStore2.default.isMenuTypeRow();

            var itemDetails = this.props.itemDetails;

            var partitionedItems = void 0;

            if (isMenuTypeRowConfig) {
                partitionedItems = (0, _chunk2.default)(itemDetails, 50);
            } else {
                partitionedItems = (0, _chunk2.default)(itemDetails, 3);
            }
            // let chunkArraySize = isMenuTypeRowConfig ?  2: 3;


            var isGroupAvailable = true;

            if (this.props.openHours) {
                // get date time based on the location
                var dateTime = _MainStore2.default.getCurrentDateTime();

                isGroupAvailable = Utils.isResturantOpen(this.props.openHours, dateTime);
            }

            // let rowClass = isMenuTypeRowConfig ? "row row-cusItem" : "row";

            return partitionedItems.map(function (items, idx) {
                return _react2.default.createElement(RowItem, {
                    key: (0, _uniqueId2.default)('item_row_'),
                    items: items,
                    isResturantOpen: _this2.props.isResturantOpen,
                    isGroupAvailable: isGroupAvailable
                    // rowClass         = {rowClass}
                    // loadScheduleScreen         = {this.props.loadScheduleScreen}
                    // handleScheduleModal  = {this.props.handleScheduleModal}
                    // showScheduleModal = {this.props.showScheduleModal}
                });
            });
        }
    }]);

    return ItemList;
}(_react2.default.Component);

exports.default = ItemList;


var RowItem = function RowItem(_ref) {
    var items = _ref.items,
        isResturantOpen = _ref.isResturantOpen,
        isGroupAvailable = _ref.isGroupAvailable;


    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        items.map(function (item) {
            return _react2.default.createElement(_itemPreview2.default, {
                key: item.objectId,
                item: item,
                isResturantOpen: isResturantOpen,
                isGroupAvailable: isGroupAvailable
                // loadScheduleScreen={loadScheduleScreen}
                // callbackParent={handleScheduleModal}
                // showScheduleModal = {showScheduleModal}
            });
        })
    );
};


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemList.jsx
// module id = 446
// module chunks = 0